<template>
  <div v-if="!loading">
    <form>
      <v-card class="my-5">
        <v-card-title>Identifikačné údaje o klientovi</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="3">
              <v-text-field v-model="form.meno_a_priezvisko" disabled label="Meno a priezvisko"
                name="Meno a priezvisko" />
            </v-col>

            <v-col v-if="form.birth_number" cols="2">
              <v-text-field v-model="form.birth_number" disabled label="Rodné číslo" name="Rodné číslo" />
            </v-col>

            <v-col v-if="'base_number' in form" cols="3">
              <v-text-field v-model="form.base_number" readonly label="Základné číslo vo VTOS"
                name="Základné číslo vo VTOS" append-icon="mdi-information-outline"
                @click:append="showInfo('base_number')" />
            </v-col>

            <v-col cols="3">
              <v-text-field v-model="form.birth_date" disabled label="Dátum narodenia" name="Dátum narodenia" />
            </v-col>
            <v-col cols="1">
              <v-text-field v-model="form.age" disabled label="Vek" name="Vek" />
            </v-col>
          </v-row>

          <v-text-field v-if="'obmedzenia' in form" v-model="form.obmedzenia" readonly label="Obmedzenia"
            name="Obmedzenia" append-icon="mdi-information-outline" @click:append="showInfo('obmedzenia')" />

          <v-row>
            <v-col>
              <v-text-field v-model="form.nastup_do_vt" disabled label="Nástup do VT" name="Nástup do VT" />
            </v-col>
            <v-col>
              <v-text-field v-model="form.dlzka_trestu" disabled label="Dĺžka trestu" name="Dĺžka trestu" />
            </v-col>
            <v-col>
              <v-text-field v-model="form.recidiva" disabled label="Recidíva" name="Recidíva" />
            </v-col>
            <v-col>
              <v-text-field v-model="form.datum_pp" disabled label="Dátum PP" name="Dátum PP" />
            </v-col>
            <v-col>
              <v-switch v-model="form.prepusteny_na_pp" label="Bol prepustený na PP" />
            </v-col>
            <v-col>
              <v-text-field v-model="form.koniec_trestu" disabled label="Koniec trestu" name="Koniec trestu" />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea v-model="form.druh_trestnej_cinnosti" auto-grow rows="1" disabled
                label="Druh trestnej činnosti (paragrafy)" name="Druh trestnej činnosti (paragrafy)" />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card class="my-5">
        <v-card-title>
          Zaradenie VO
          <v-spacer />
          <v-btn icon @click="showInfo('zaradenie_vo')">
            <v-icon>mdi-information-outline</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row v-for="(input, index) in form.zaradenie_vo" :key="index">
            <v-col cols="2">
              <date-picker-custom v-model="input.zaradenie_do_vo" name="Dátum od" />
            </v-col>
            <v-col cols="2">
              <date-picker-custom v-model="input.vyradenie_z_vo" name="Dátum do" />
            </v-col>
            <v-col cols="8">
              <v-textarea v-model="input.popis" label="Popis" name="Popis" rows="1" auto-grow append-icon="mdi-delete"
                @click:append="deleteRowZaradenieVO(index)" />
            </v-col>
          </v-row>

          <v-btn text icon color="secondary" @click="addRowZaradenieVO">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-card-text>
      </v-card>

      <h1 class="title-1 text-center">
        Diagnostika klienta
      </h1>

      <v-card class="my-5">
        <v-card-title>Rodinná a vzťahová anamnéza</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="3">
              <v-select v-model="form.rodinny_stav" label="Rodinný stav" name="Rodinný stav"
                :items="selects.rodinny_stav" append-icon="mdi-information-outline"
                @click:append="showInfo('rodinny_stav')" />
            </v-col>
            <v-col cols="9">
              <v-textarea v-model="form.rodinny_stav_popis" auto-grow rows="1" label="Popis" name="Popis"
                append-icon="mdi-information-outline" @click:append="showInfo('rodinny_stav_popis')" />
            </v-col>
          </v-row>

          <v-text-field v-model="form.pocet_deti_celkovo" label="Počet detí celkovo" name="Počet detí celkovo"
            append-icon="mdi-information-outline" @click:append="showInfo('pocet_deti_celkovo')" />

          <v-select v-model="form.odporucane_intervencie" label="Odporúčané intervencie" name="Odporúčané intervencie"
            :items="selects.odporucane_intervencie" append-icon="mdi-information-outline"
            @click:append="showInfo('odporucane_intervencie')" />
        </v-card-text>
      </v-card>

      <v-card v-if="form.kontakty_pocas_trvania_trestu" class="my-5">
        <v-card-title>
          Kontakty počas trvania výkonu trestu
          <v-spacer />
          <v-btn icon @click="showInfo('kontakty_pocas_trvania')">
            <v-icon>mdi-information-outline</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-card v-for="(input, index) in form.kontakty_pocas_trvania_trestu" :key="index" class="my-3 mx-auto">
            <v-card-text>
              <v-row>
                <v-col cols="2">
                  <v-text-field v-model="input.pocetnost_pocet" type="number" label="Koľkokrát" name="Koľkokrát" />
                </v-col>
                <v-col cols="2">
                  <v-select v-model="input.pocetnost_jednotka" label="Frekvencia" name="Frekvencia"
                    :items="selects.kontakty.jednotka" />
                </v-col>

                <v-col cols="2">
                  <date-picker-custom v-model="input.datum_od" name="Dátum od" />
                </v-col>
                <v-col cols="2">
                  <date-picker-custom v-model="input.datum_do" name="Dátum do" />
                </v-col>

                <v-spacer />
                <v-btn icon @click="deleteRowKontakty(index)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-textarea v-model="input.popis" label="Popis" name="Popis" rows="1" auto-grow />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-btn text icon color="secondary" @click="addRowKontakty">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-card-text>
      </v-card>

      <v-card class="my-5">
        <v-card-title>
          Bývanie (pred nástupom do výkonu trestu odňatia slobody, po skončení
          výkonu trestu odňatia slobody)
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="9">
              <v-text-field v-model="form.trvale_bydlisko" label="Trvalé bydlisko" name="Trvalé bydlisko"
                append-icon="mdi-information-outline" @click:append="showInfo('trvale_bydlisko')" />
            </v-col>
            <v-col cols="3">
              <v-select v-model="form.trvale_bydlisko_popis" label="Trvalé bydlisko popis" name="Trvalé bydlisko popis"
                :items="selects.byvanie.popis" append-icon="mdi-information-outline"
                @click:append="showInfo('trvale_bydlisko_popis')" />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="9">
              <v-text-field v-model="form.prechodne_bydlisko" label="Prechodné bydlisko" name="Prechodné bydlisko"
                append-icon="mdi-information-outline" @click:append="showInfo('prechodne_bydlisko')" />
            </v-col>
            <v-col cols="3">
              <v-select v-model="form.prechodne_bydlisko_popis" label="Prechodné bydlisko popis"
                name="Prechodné bydlisko popis" :items="selects.byvanie.popis" append-icon="mdi-information-outline"
                @click:append="showInfo('prechodne_bydlisko_popis')" />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="9">
              <v-text-field v-model="form.obvykly_pobyt" label="Obvyklý pobyt" name="Obvyklý pobyt"
                append-icon="mdi-information-outline" @click:append="showInfo('obvykly_pobyt')" />
            </v-col>
            <v-col cols="3">
              <v-select v-model="form.obvykly_pobyt_popis" label="Obvyklý pobyt popis" name="Obvyklý pobyt popis"
                :items="selects.byvanie.popis" append-icon="mdi-information-outline"
                @click:append="showInfo('obvykly_pobyt_popis')" />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="2">
              <v-select v-model="form.skusenosti_s_bezdomovectvom" label="Skúsenosti s bezdomovectvom"
                name="Skúsenosti s bezdomovectvom" :items="selects.checkbox" append-icon="mdi-information-outline"
                @click:append="showInfo('skusenosti_s_bezdomovectvom')" />
            </v-col>
            <v-col cols="2">
              <v-select v-model="form.byvanie_v_segregovanej_komunite" label="Bývanie v segregovanej komunite"
                name="Bývanie v segregovanej komunite" :items="selects.checkbox" append-icon="mdi-information-outline"
                @click:append="showInfo('byvanie_v_segregovanej_komunite')" />
            </v-col>
            <v-col cols="2">
              <v-select v-model="form.riesenie_ubytovania" label="Riešenie ubytovania" name="Riešenie ubytovania"
                :items="selects.checkbox" append-icon="mdi-information-outline"
                @click:append="showInfo('riesenie_ubytovania')" />
            </v-col>
            <v-col cols="2">
              <v-select v-model="form.potvrdenie_o_deinfekcnosti" label="Potvrdenie o bezinfekčnosti"
                name="Potvrdenie o bezinfekčnosti" :items="selects.checkbox" append-icon="mdi-information-outline"
                @click:append="showInfo('potvrdenie_o_deinfekcnosti')" />
            </v-col>
          </v-row>

          <v-textarea v-model="form.byvanie_popis" auto-grow rows="1" label="Popis" name="Popis"
            append-icon="mdi-information-outline" @click:append="showInfo('byvanie_popis')" />
        </v-card-text>
      </v-card>

      <v-card class="my-5">
        <v-card-title>Vzdelanie</v-card-title>
        <v-card-text>
          <v-select v-model="form.najvyssie_dosiahnute_vzdelanie" label="Najvyššie dosiahnuté vzdelanie"
            name="Najvyššie dosiahnuté vzdelanie" :items="selects.vzdelanie.najvyssie_dosiahnute_vzdelanie"
            append-icon="mdi-information-outline" @click:append="showInfo('najvyssie_dosiahnute_vzdelanie')" />

          <v-textarea v-model="form.odbor" auto-grow rows="1" label="Odbor" name="Odbor"
            append-icon="mdi-information-outline" @click:append="showInfo('odbor')" />

          <v-textarea v-model="form.ine_vzdelanie_pred_vtos" auto-grow rows="1"
            label="Iné vzdelanie (nadobudnuté pred nástupom do VTOS)"
            name="Iné vzdelanie (nadobudnuté pred nástupom do VTOS)" append-icon="mdi-information-outline"
            @click:append="showInfo('ine_vzdelanie_pred_vtos')" />
        </v-card-text>
      </v-card>

      <v-card class="my-5">
        <v-card-title>Zamestnanie</v-card-title>
        <v-card-text>
          <v-select v-model="form.zamestnany_nepretrzite" readonly
            label="Zamestnaný nepretržite celých 12 mesiacov pred nástupom do VTOS"
            name="Zamestnaný nepretržite celých 12 mesiacov pred nástupom do VTOS" :items="selects.checkbox"
            append-icon="mdi-information-outline" @click:append="showInfo('zamestnany_nepretrzite')" />

          <v-textarea v-model="form.posledny_zamestnavatel" auto-grow rows="1"
            label="Posledný zamestnávateľ (pred nástupom do VTOS)" name="Posledný zamestnávateľ (pred nástupom do VTOS)"
            append-icon="mdi-information-outline" @click:append="showInfo('posledny_zamestnavatel')" />

          <v-textarea v-model="form.druh_vykonavanej_prace" auto-grow rows="1" label="Druh vykonávanej práce"
            name="Druh vykonávanej práce" append-icon="mdi-information-outline"
            @click:append="showInfo('druh_vykonavanej_prace')" />

          <v-row>
            <v-col cols="2">
              <v-select v-model="form.evidovany_na_upsvr" label="Evidovaný na ÚPSVR" name="Evidovaný na ÚPSVR"
                :items="selects.checkbox" append-icon="mdi-information-outline"
                @click:append="showInfo('evidovany_na_upsvr')" />
            </v-col>
            <v-col cols="2">
              <v-select v-model="form.poberatel_dvh_hn" label="Poberateľ DVN/HN" name="Poberateľ DVN/HN"
                :items="selects.checkbox" append-icon="mdi-information-outline"
                @click:append="showInfo('poberatel_dvh_hn')" />
            </v-col>
            <v-col cols="2">
              <v-select v-model="form.nelegalna_praca" label="Nelegálna práca" name="Nelegálna práca"
                :items="selects.checkbox" append-icon="mdi-information-outline"
                @click:append="showInfo('nelegalna_praca')" />
            </v-col>
          </v-row>

          <v-textarea v-model="form.zamestnanie_ine" auto-grow rows="1" label="Iné" name="Iné" />
        </v-card-text>
      </v-card>

      <v-card class="my-5">
        <v-card-title>Financie</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="2">
              <v-select v-model="form.dlhy_a_exekucie" label="Dlhy a exekúcie" name="Dlhy a exekúcie"
                :items="selects.checkbox" append-icon="mdi-information-outline"
                @click:append="showInfo('dlhy_a_exekucie')" />
            </v-col>
            <v-col cols="2">
              <v-select v-model="form.ma_financie_na_cestu" label="Má financie na cestu domov"
                name="Má financie na cestu domov" :items="selects.checkbox" append-icon="mdi-information-outline"
                @click:append="showInfo('ma_financie_na_cestu')" />
            </v-col>
            <v-col cols="2">
              <v-select v-model="form.poberatel_dochodkovej_davky" label="Poberateľ dôchodkovej dávky"
                name="Poberateľ dôchodkovej dávky" :items="selects.checkbox" append-icon="mdi-information-outline"
                @click:append="showInfo('poberatel_dochodkovej_davky')" />
            </v-col>
            <v-col cols="2">
              <v-select v-model="form.dochodok_vo_vybavovani" label="Dôchodok vo vybavovaní"
                name="Dôchodok vo vybavovaní" :items="selects.checkbox" append-icon="mdi-information-outline"
                @click:append="showInfo('dochodok_vo_vybavovani')" />
            </v-col>
            <v-col cols="2">
              <v-select v-model="form.dlh_na_zdravotnom" label="Dlh na zdravotnom poistení"
                name="Dlh na zdravotnom poistení" :items="selects.checkbox" append-icon="mdi-information-outline"
                @click:append="showInfo('dlh_na_zdravotnom')" />
            </v-col>
            <v-col cols="2">
              <v-select v-model="form.dlh_na_socialnom" label="Dlh na sociálnom poistení"
                name="Dlh na sociálnom poistení" :items="selects.checkbox" append-icon="mdi-information-outline"
                @click:append="showInfo('dlh_na_socialnom')" />
            </v-col>
          </v-row>

          <v-textarea v-model="form.financie_ine" auto-grow rows="1" label="Iné" name="Iné"
            append-icon="mdi-information-outline" @click:append="showInfo('financie_ine')" />
        </v-card-text>
      </v-card>

      <v-card class="my-5">
        <v-card-title>Doklady</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="3">
              <date-picker-custom v-model="form.obciansky_preukaz_platnost" name="Občiansky preukaz platnosť do" />
            </v-col>
            <v-col cols="2">
              <v-select v-model="form.obciansky_preukaz_poziadal_o_vybavenie"
                label="Občiansky preukaz požiadal/a o vybavenie" name="Občiansky preukaz požiadal/a o vybavenie"
                :items="selects.checkbox" append-icon="mdi-information-outline"
                @click:append="showInfo('obciansky_preukaz_poziadal_o_vybavenie')" />
            </v-col>
            <v-col cols="3">
              <v-select v-model="form.zdravotna_poistovna" label="Zdravotná poisťovňa" name="Zdravotná poisťovňa"
                :items="selects.zdravotna_poistovna" />
            </v-col>
            <v-col cols="2">
              <v-select v-model="form.preukaz_zdravotneho_poistenia_vlastni"
                label="Preukaz zdravotného poistenia fyzicky vlastní"
                name="Preukaz zdravotného poistenia fyzicky vlastní" :items="selects.checkbox"
                append-icon="mdi-information-outline"
                @click:append="showInfo('preukaz_zdravotneho_poistenia_vlastni')" />
            </v-col>
            <v-col cols="2">
              <v-select v-model="form.preukaz_zdravotneho_poistenia_poziadal_o_vybavenie
                " label="Preukaz zdravotného poistenia požiadal o vybavenie"
                name="Preukaz zdravotného poistenia požiadal o vybavenie" :items="selects.checkbox"
                append-icon="mdi-information-outline"
                @click:append="showInfo('preukaz_zdravotneho_poistenia_poziadal_o_vybavenie')" />
            </v-col>
          </v-row>

          <v-textarea v-model="form.doklady_ine" auto-grow rows="1" label="Iné" name="Iné"
            append-icon="mdi-information-outline" @click:append="showInfo('doklady_ine')" />
        </v-card-text>
      </v-card>

      <v-layout v-if="!form.closed" pt-5>
        <v-btn class="ma-2" fixed right bottom dark rounded color="primary" @click="updateItem()">
          uložiť
        </v-btn>
        <div class="flex-grow-1" />
      </v-layout>
    </form>

    <v-dialog v-model="dialog" width="800px">
      <v-card>
        <v-toolbar dark color="indigo">
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ dialog_item.nazov }}</v-toolbar-title>
          <div class="flex-grow-1" />
        </v-toolbar>
        <v-card>
          <v-card-text>
            <p v-for="item in dialog_item.charakteristika" :key="item.nazov">
              {{ item }}
            </p>
          </v-card-text>
        </v-card>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar_saved" color="success" :timeout="3000">
      Uložené
      <v-btn text @click="snackbar_saved = false">
        Zavrieť
      </v-btn>
    </v-snackbar>
    <v-snackbar v-model="snackbar_error" color="error" :timeout="5000">
      Chyba
    </v-snackbar>
  </div>

  <div v-else>
    <form-skeleton-component skeleton_type="UdajeOKlientovi" />
  </div>
</template>

<script>
import { APIService } from "@/http/APIService.js";
import FormSkeleton from "../components/FormSkeleton.vue";
import DatePickerCustom from "@/components/DatePickerCustom.vue"

const apiService = new APIService();

export default {
  components: {
    "form-skeleton-component": FormSkeleton,
    "date-picker-custom": DatePickerCustom,
    DatePickerCustom
  },
  data: () => ({
    dialog: false,
    dialog_item: {
      nazov: "",
      charakteristika: []
    },
    loading: false,
    snackbar_saved: false,
    snackbar_error: false,

    form: {
      id: null,
      meno_a_priezvisko: "",
      kontakty_pocas_trvania_trestu: [
        {
          popis: "",
        },
      ],
      rodina_a_blizke_osoby: [
        {
          type: "",
          meno: "",
          priezvisko: "",
          adresa: "",
          kontakt: "",
          ine: "",
        },
      ],
      blizke_osoby_string: "{}",
    },

    selects: {
      zdravotna_poistovna: [
        "24 – DÔVERA zdravotná poisťovňa, a.s.",
        "25 – VŠEOBECNÁ zdravotná poisťovňa, a.s.",
        "27 – UNION zdravotná poisťovňa, a.s.",
        ""
      ],
      kontakty: {
        jednotka: [
          "Týždenne",
          "Mesačne",
          "Ročne"
        ]
      },
      checkbox: [
        {
          text: "áno",
          value: true
        },
        {
          text: "nie",
          value: false
        },
        {
          text: "nevyplnené",
          value: null
        }
      ],
      rodinny_stav: [
        "slobodný/slobodná",
        "ženatý/vydatá",
        "rozvedený/rozvedená",
        "vdovec/vdova",
        "druh/družka",
        "iné",
      ],
      rodina_a_blizke_osoby: {
        typ: [
          "matka",
          "otec",
          "plnoleté dieťa",
          "partner(ka)",
          "súrodenec",
          "iné blízke osoby/vzťah ku klientovi",
        ],
      },
      byvanie: {
        popis: [
          "vlastník",
          "nájomca",
          "bezdomovec",
          "u rodičov",
          "nemá",
          "iné",
        ],
      },
      vzdelanie: {
        najvyssie_dosiahnute_vzdelanie: [
          "III. stupeň vysokej školy",
          "II. stupeň vysokej školy",
          "I. stupeň vysokej školy",
          "úplné stredné všeobecné vzdelanie s maturitou (gymnázium)",
          "úplné stredné odborné vzdelávanie s maturitou",
          "stredné odborné vzdelanie bez maturity s výučným listom/resp. záučným listom",
          "špeciálna škola",
          "ukončená základná škola",
          "neukončený II. stupeň základnej školy",
          "neukončený I. stupeň základnej školy",
          "negramotný",],
      },
      odporucane_intervencie: [
        "CAN syndróm",
        "Rodičovské zručnosti",
        "Výchovné poradenstvo",
        "Domáce násilie",
        "Sanácia rodinného prostredia",
        "Krízová intervencia",
        "Konkrétna sociálna služba (448/2008)",
        "Svojpomocná skupina",
        "Ambulantná starostlivosť (druh)",
        "Rezidenciálna starostlivosť (druh)",
        "Poradenstvo v oblasti práce",
        "Poradenstvo v oblasti ubytovania",
        "Poradenstvo v oblasti financií",
        "Poradenstvo v oblasti práva",
        "Poradenstvo v oblasti vzťahov",
        "Poradenstvo v oblasti sebarealizácie",
        "Poradenstvo v oblasti závislostí",
        "Podpora rodičovských zručností",
        "Iné"
      ],
    },

    manual: {
      base_number: {
        nazov: "Základné číslo vo VTOS",
        charakteristika: [
          "Základné číslo vo VTOS – je uvedené aktuálne základné číslo",
          "- v prípade recidívy a opätovného umiestnenia vo výstupnom oddiele sa v IAPSZ z.č. aktualizuje",
          "- v prípade recidívy a opätovného umiestnenia vo výstupnom oddiele sa v IAPSZ údaje aktualizujú – v prípade už založeného IAPSZ."
        ],
      },
      obmedzenia: {
        nazov: "Obmedzenia",
        charakteristika: [
          "položka je vypĺňaná automaticky zo systému VVVT, nie je možné ju dopĺňať (GDPR)"
        ]
      },

      zaradenie_do_vo: {
        nazov: "Zaradenie do VO",
        charakteristika: [
          "dátum zaradenia do výstupného oddielu(vyplniť manuálne)"
        ]
      },

      vyradenie_z_vo: {
        nazov: "Vyradenie z VO",
        charakteristika: [
          "dátum vyradenia z výstupného oddielu (vyplniť manuálne)"
        ]
      },

      rodinny_stav: {
        nazov: "Rodinný stav",
        charakteristika: ["vypĺňané automaticky"]
      },

      rodinny_stav_popis: {
        nazov: "Popis",
        charakteristika: ["priestor pre dôležité skutočnosti ktoré môžu mať vplyv na recidívu (podporné aj rizikové)"]
      },

      pocet_deti_celkovo: {
        nazov: "Počet detí celkovo",
        charakteristika: ["vypĺňané automaticky"]
      },

      odporucane_intervencie: {
        nazov: "Odporúčané poradenstvo",
        charakteristika: [
          "myslí sa po prepustení",
        ]
      },

      kontakty_pocas_trvania: {
        nazov: "Kontakty počas trvania výkonu trestu",
        charakteristika: [
          "V kontaktoch sa uvádza obdobie, frekvencia a osoby, resp. organizácie dôležité pre resocializáciu. (napr. Manželka od 1/2015-5/2017 2 x mesačne pravidelne každý mesiac. Od 6/2017.)"
        ]
      },

      trvale_bydlisko: {
        nazov: "Trvalé bydlisko",
        charakteristika: [
          "-	vypĺňané automaticky",
          "-	podľa trvalého bydliska sa automaticky určuje príslušný UPSVR kde bude sprístupnené IAPSZ po prepustení (je možnosť zmeniť príslušnosť UPSVR manuálne)"
        ]
      },

      trvale_bydlisko_popis: {
        nazov: "Trvalé bydlisko popis",
        charakteristika: [
          "-	uvádzajú sa dôležité skutočnosti viažuce sa k bydlisku (napr. Len na 6 mesiacov, byt v dražbe a pod.)",
          "-	ak je to relevantné, príležitosti a ohrozenia je potrebné doplniť aj v SWOT analýze v časti bývanie"
        ]
      },

      prechodne_bydlisko: {
        nazov: "Prechodné bydlisko",
        charakteristika: [
          "vypĺňané automaticky"
        ]
      },

      prechodne_bydlisko_popis: {
        nazov: "Prechodné bydlisko popis",
        charakteristika: [
          "-	uvádzajú sa dôležité skutočnosti viažuce sa k prechodnému pobytu (napr. Len na 6 mesiacov, byt v dražbe a pod.)",
          "-	ak je to relevantné, príležitosti a ohrozenia je potrebné doplniť aj v SWOT analýze v časti bývanie"
        ]
      },

      obvykly_pobyt: {
        nazov: "Obvyklý pobyt",
        charakteristika: [
          "vypĺňané automaticky"
        ]
      },
      obvykly_pobyt_popis: {
        nazov: "Obvyklý pobyt popis",
        charakteristika: [
          "-	uvádzajú sa dôležité skutočnosti viažuce sa k prechodnému pobytu (napr. Len na 6 mesiacov, byt v dražbe a pod.)",
          "-	ak je to relevantné, príležitosti a ohrozenia je potrebné doplniť aj v SWOT analýze v časti bývanie"
        ]
      },

      skusenosti_s_bezdomovectvom: {
        nazov: "Skúsenosti s bezdomovectvom",
        charakteristika: [
          "pole sa zaškrtne v prípade ak mal odsúdený minulú skúsenosť s bezdomovectvom"
        ]
      },

      byvanie_v_segregovanej_komunite: {
        nazov: "Bývanie v segregovanej komunite",
        charakteristika: [
          "pole sa zaškrtne v prípade ak odsúdený má pobyt v segregovanej komunite"
        ]
      },

      riesenie_ubytovania: {
        nazov: "Riešenie ubytovania",
        charakteristika: [
          "pole sa zaškrtne v prípade ak si odsúdený aktuálne rieši bývanie"
        ]
      },

      potvrdenie_o_deinfekcnosti: {
        nazov: "Potvrdenie o bezinfekčnosti",
        charakteristika: [
          "pole sa zaškrtne v prípade ak odsúdený potvrdenie má (resp. bude mať pred prepustením)"
        ]
      },

      byvanie_popis: {
        nazov: "Popis",
        charakteristika: [
          "uvádzajú sa dôležité skutočnosti viažuce sa k bývaniu (odsúdený po prepustení má zabezpečené bývanie na týždeň v nocľahárni smutná vŕba, 1.7. priletí brat odsúdeného z GB a chcú riešiť spoločne prenájom (z dôvodu financií). Na 2 mesiace nemá zabezpečené bývanie. Čakáme na vyjadrenie možnosti bývania miestnej fary."
        ]
      },

      najvyssie_dosiahnute_vzdelanie: {
        nazov: "Najvyššie dosiahnuté vzdelanie",
        charakteristika: [
          "vypĺňané automaticky"
        ]
      },

      odbor: {
        nazov: "Odbor",
        charakteristika: [
          "ak je to relevantné, manuálne treba doplniť odbor"
        ]
      },

      ine_vzdelanie_pred_vtos: {
        nazov: "Iné vzdelanie (nadobudnuté pred nástupom do VTOS)",
        charakteristika: [
          "ak je to relevantné, manuálne treba doplniť (napr. Kuchár)"
        ]
      },

      zamestnany_nepretrzite: {
        nazov: "Zamestnaný nepretržite celých 12 mesiacov pred nástupom do VTOS",
        charakteristika: [
          "položka sa automaticky zaškrtne ak bol odsúdený zamestnaný nepretržite celých 12 mesiacov pred nástupom do VTOS."
        ]
      },

      posledny_zamestnavatel: {
        nazov: "Posledný zamestnávateľ",
        charakteristika: ["Treba vyplniť posledného zamestnávateľa pred nástupom odsúdeného do VTOS. Položka je dôležitá pre prípadne kontaktovanie zamestnávateľa a smerovanie odsúdeného."]
      },

      druh_vykonavanej_prace: {
        nazov: "Druh vykonávanej práce",
        charakteristika: ["Treba vyplniť akú prácu odsúdený vykonával (drevorubač, obkladač, kosec a pod.)"]
      },

      evidovany_na_upsvr: {
        nazov: "Evidovaný na ÚPSVR",
        charakteristika: [
          "Treba označiť v prípade, že bol odsúdený pred nástupom do VTOS evidovaný na ÚPSVR"
        ]
      },

      poberatel_dvh_hn: {
        nazov: "Poberateľ DVN/HN",
        charakteristika: [
          "Treba označiť v prípade, že bol odsúdený pred nástupom do VTOS poberateľ dávok pomoci v hmotnej núdzi"
        ]
      },

      nelegalna_praca: {
        nazov: "Nelegálna práca",
        charakteristika: [
          "Treba označiť v prípade, že odsúdený má skúsenosť s prácou „na čierno“ bez zmluvy. Položka smeruje charakter intervencií v oblasti zamestnanosti (dôvody nelegálnej práce, eliminácia dôvodov (napr. exekúcie), nevýhody nelegálnej práce (sociálne zabezpečenie, úrazy a pod.)"
        ]
      },

      dlhy_a_exekucie: {
        nazov: "Dlhy a exekúcie",
        charakteristika: [
          "Treba označiť v prípade, že má odsúdený dlhy a exekúcie. V prípade dlhov a exekúcií je dôležité túto skutočnosť zachytiť v SWOT analýze (oblasť Financie/ohrozenia)"
        ]
      },

      ma_financie_na_cestu: {
        nazov: "Má financie na cestu domov",
        charakteristika: [
          "Treba označiť v prípade, že odsúdený má dostatok finančných prostriedkov na cestu domov."
        ]
      },

      poberatel_dochodkovej_davky: {
        nazov: "Poberateľ dôchodkovej dávky",
        charakteristika: [
          "Treba označiť v prípade, že odsúdený je poberateľ dôchodkovej dávky."
        ]
      },

      dochodok_vo_vybavovani: {
        nazov: "Dôchodok vo vybavovaní",
        charakteristika: [
          "Treba označiť v prípade ak odsúdený spustil proces vybavenia si dôchodkovej dávky. Túto skutočnosť treba zaznamenať v SWOT analýze (oblasť Financie/príležitosti)."
        ]
      },

      dlh_na_zdravotnom: {
        nazov: "Dlh na zdravotnom poistení",
        charakteristika: [
          "Treba označiť v prípade, že odsúdený má dlh na zdravotnom poistení. Túto skutočnosť je dôležité zaznamenať v SWOT analýze (oblasť Financie/ohrozenia). Zároveň je dôležité naplánovať si kroky na riešenie dlhu (napr. splátkový kalendár)."
        ]
      },

      dlh_na_socialnom: {
        nazov: "Dlh na sociálnom poistení",
        charakteristika: [
          "Treba označiť v prípade, že odsúdený má dlh v sociálnej poisťovni. Túto skutočnosť je dôležité zaznamenať v SWOT analýze (oblasť Financie/ohrozenia). Zároveň je dôležité naplánovať si kroky na riešenie dlhu (napr. splátkový kalendár)."
        ]
      },

      financie_ine: {
        nazov: "Iné",
        charakteristika: [
          "Do tejto časti je možné doplniť akékoľvek dôležité skutočnosti viažuce sa k financiám."
        ]
      },

      obciansky_preukaz_platnost: {
        nazov: "Občiansky preukaz platnosť do",
        charakteristika: [
          "Treba označiť v kalendári dátum, do kedy má odsúdený platný občiansky preukaz."
        ]
      },

      obciansky_preukaz_poziadal_o_vybavenie: {
        nazov: "Občiansky preukaz požiadal/a o vybavenia",
        charakteristika: [
          "Treba označiť v prípade ak odsúdený podal žiadosť o vybavenie si občianskeho preukazu."
        ]
      },

      preukaz_zdravotneho_poistenia_vlastni: {
        nazov: "Preukaz zdravotného poistenia fyzicky vlastní",
        charakteristika: [
          "Treba označiť v prípade ak odsúdený fyzicky vlastní preukaz zdravotného poistenia."
        ]
      },

      preukaz_zdravotneho_poistenia_poziadal_o_vybavenie: {
        nazov: "Preukaz zdravotného poistenia požiadal o vybavenie",
        charakteristika: [
          "Treba označiť v prípade ak odsúdený podal žiadosť o vybavenie si preukazu zdravotného poistenia."
        ]
      },

      doklady_ine: {
        nazov: "Iné",
        charakteristika: [
          "Do tejto časti je možné doplniť akékoľvek dôležité skutočnosti viažuce sa k dokladom."
        ]
      }
    },
  }),

  computed: {
    // blizke_osoby_vvvt: function () {
    //   return JSON.parse(this.form.blizke_osoby_string);
    // },
  },

  created() {
    this.getItem();
  },

  methods: {
    showInfo(nazov) {
      this.dialog = true;
      this.dialog_item = this.manual[nazov];
    },
    getItem() {
      this.loading = true;
      apiService
        .getIapszUdajeOKlientovi(this.$route.params.id)
        .then((response) => {
          this.form = response;
          this.loading = false;
        });
    },

    updateItem() {

      apiService
        .updateIapszUdajeOKlientovi(this.form, this.$route.params.id)
        .then(
          () => {
            this.snackbar_saved = true;
          },
          () => {
            this.snackbar_error = true;
          }
        );
    },

    addRowKontakty() {
      this.form.kontakty_pocas_trvania_trestu.push({
        udaje_o_klientovi: this.form.id,
        pocetnost_pocet: null,
        pocetnost_jednotka: null,
        datum_od: null,
        datum_do: null,
        popis: null,
      });
    },
    deleteRowKontakty(index) {
      this.form.kontakty_pocas_trvania_trestu.splice(index, 1);
    },

    addRowZaradenieVO() {
      this.form.zaradenie_vo.push({
        udaje_o_klientovi: this.form.id,
        zaradenie_do_vo: null,
        vyradenie_z_vo: null,
        popis: "",
      });
    },
    deleteRowZaradenieVO(index) {
      this.form.zaradenie_vo.splice(index, 1);
    },
  },
};
</script>